export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_kk.f3102b0950a1b903.json"